<span *ngIf="navigationService.openMenu | async" class="open-menu-bg"></span>
<div class="container">
  <div class="navigation-body">
    <a class="navigation-row" href="">
      <img class="logo"
           src="../../../assets/img/logo_BF.png"
           alt="icon">
    </a>
    <div [ngClass]="{'navigation-row-mobile':true,'navigation-row-mobile-open': navigationService.openMenu | async}">
      <nav class="navigation">
        <ul class="navigation-container">
          <li class="navigation-item">
            <a class="navigation-item-link" href="https://partners.busy-fly.com/">
              стать партнером</a>
          </li>
          <li class="navigation-item"
              *ngIf="requisitesVisibility">
            <a class="navigation-item-link" href="/ru/rekvizity-partnyorov">
              реквизиты партнёров</a>
          </li>
          <li *ngIf="howToRide" class="navigation-item" [routerLink]="'../how-to-ride'"
              routerLinkActive="active">
            как кататься
          </li>
          <li *ngIf="aboutVisibility"
              class="navigation-item" (click)="toAbout()">как кататься
          </li>
          <li *ngIf="tariffVisibility"
              class="navigation-item" (click)="toTariff()">тарифы
          </li>
        </ul>
      </nav>
    </div>
    <div class="open-menu" (click)="navigationService.openMenu.next(!navigationService.openMenu.value)"
         [ngClass]="{'closeMenu':navigationService.openMenu | async}">
      <span class="menu-burger"></span>
    </div>
  </div>
</div>
